<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-18 11:21:01
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/order/purchase/components/PurBtn/index.vue
-->
<template>
  <div class="con">
    <div class="font12 font_weight500 line_height_17 order_total">
      应付金额：{{ preCheckout.totalPrice | currency(false) }}
    </div>
    <div
      class="font12 font_weight500 line_height_17 colof order_btn"
      @click="submitBtn"
    >
      提交订单
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    preCheckout() {
      return this.$store.getters.preCheckout;
    }
  },
  methods: {
    submitBtn() {
      this.$emit("submitBtn");
    }
  }
};
</script>

<style lang="less" scoped>
.con {
  background: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  padding: 6px 12px;
  align-items: center;
  .order_total {
    color: #f23030;
  }
  .order_btn {
    background: linear-gradient(180deg, #e8caa1 0%, #bf9264 100%);
    box-shadow: -1px -1px 4px 0px rgba(255, 255, 255, 0.5);
    border-radius: 18px;
    padding: 10px 31px;
  }
}
</style>
